import { useModel } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import ContentSubheaderView from 'components/shared/views/ContentSubheaderView';
import React, { useEffect } from 'react';
import "./styles.css";
/**
 * @function CreditScorePage
 * @return {React.Component}
 * @exported true
 * @description The main component for CreditScorePage
 */
export default function CreditScorePage(props) {
  const { branding } = useModel();
  const options = branding.options;
  const subheaderText = options.creditscore_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  const mabiBranding = window.mabi23Branding;
  const option = mabiBranding
    ? mabiBranding.options.integrated_page_header_mabi23
    : options.integrated_page_header_abi22;
  const showHeader = option !== "false";
  
  useEffect(() => {
    // If the demo is in a mobilew view (MABI23 included) execute this code 
    // that will make the page unscrollable  except for the iframe.
    if(window.innerWidth <= 625) {
      const creditScorePage = document.querySelector(".credit-score-page");
      creditScorePage.style.height = "100vh";
      creditScorePage.style.overflow = "hidden";
    }
  });
  
  return (
    <PageContainer className="credit-score-page integrated-product-page">
      <PageContentView>
        <CenterContentContainer>
          { showHeader && <ContentHeaderView text="Credit Score" /> }

          { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
          <div className="iframe-container flex-container flex-horizontal justify-center">
            {/* iFrame for CS21 goes here */}
            <ExternalIframe demo="CS21" className="credit-score-iframe"  key ="CreditScorePage"/>
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
